// Platzhalter
if (typeof console === 'undefined') {
    console = {
        log: function () {
        }
    };
}

if (typeof jQuery.fn.datepicker === 'undefined') {
    jQuery.fn.datepicker = {};
    jQuery.fn.datepicker.dates = {};
}
// entsprechend Vorlage von jQuery
jQuery.cachedScript = function (url, options) {
    options = $.extend(options || {}, {
        dataType: 'script',
        cache: true,
        url: url
    });
    return jQuery.ajax(options);
};

// Lighthouse-Hinweis - wird in jQuery4 dann "richtig" umgesetzt
// das hier ist der "offizielle" Workaround aus https://github.com/jquery/jquery/issues/2871
jQuery.event.special.touchstart = {
    setup: function (_, ns, handle) {
        this.addEventListener('touchstart', handle, {passive: true});
    }
};
jQuery.event.special.mousewheel = {
    setup: function (_, ns, handle) {
        this.addEventListener('mousewheel', handle, {passive: true});
    }
};

//https://stackoverflow.com/questions/18487056/select2-doesnt-work-when-embedded-in-a-bootstrap-modal/19574076#19574076
// Löst das Problem mit select2 im modal...
$.fn.modal.Constructor.prototype._enforceFocus = function () {
};

// das Objekt mp wird entsprechend mit Funktionsmodulen ergänzt
var mp = {
    getViewport: function () {
        return $('#mpResponsiveInfo div:visible').data('viewport');
    },
    isBot: function () {
        // Info: wenn der UA mal abgeschafft wird, muss man das anpassen
        return /bot|crawler|spider|crawling/i.test(navigator.userAgent);
    }
};
